import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import ContestStore, { WINNER_AMOUNT } from '../Contest.store'

const WinnerModal = observer(() => {
  const { pendingWinner } = ContestStore

  if (!pendingWinner) return null

  return (
    <div className='winner-modal-overlay' onClick={e => e.stopPropagation()}>
      <div className='winner-modal'>
        <div className='winner-modal-confetti' />
        <div className='winner-modal-content'>
          <div className='winner-trophy'>
            <MDBIcon icon='trophy' />
          </div>
          <h2 className='winner-name'>{pendingWinner.name}</h2>
          <h3 className='winner-amount'>Wins ${WINNER_AMOUNT} USABG Bucks!</h3>
          <p className='winner-spin'>Spin #{pendingWinner.spinIndex + 1}</p>
          <div className='winner-actions'>
            <MDBBtn type='button' color='success' size='lg' onClick={() => ContestStore.dismissWinner()}>
              <MDBIcon icon='check-circle' className='mr-1' />
              Continue
            </MDBBtn>
          </div>
        </div>
      </div>
    </div>
  )
})

export default WinnerModal
